import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  handleClick(event) {
    event.preventDefault();
    if (this.processing) {
      return;
    }
    this.toggleLoading(true);
    return this.handleUndo();
  }

  handleUndo(confirmUndo = false) {
    Swal.fire({
      title: "Aguarde",
      showConfirmButton: false,
    })
    swal.disableButtons()
    swal.showLoading()
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");
    const data = confirmUndo ? {confirm_undo: true} : {}
    return new Promise( (resolve, reject) => {
      axios
      .put(
        this.data.get("url"),
        {
          authenticity_token: csrfToken,
          ...data
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken
          }
        }
      )
      .then(response => {
        if(response.status === 200){
          if (confirmUndo) {
            this.undoComplete(response.data)
            return
          }
          this.confirmUndo(response.data)
          return
        }

        Swal.hideLoading()
        Swal.fire({
          title: "Não foi possível processar a solicitação.",
          showConfirmButton: true,
          cancelButtonText: "Cancelar"
        })
        resolve()
      })
      .catch((error) => {
        console.error(error)
        Swal.hideLoading()
        Swal.fire({
          title: "Não foi possível processar a solicitação.",
          showConfirmButton: true,
          cancelButtonText: "Cancelar"
        })
        resolve()
      })
      .finally(() => {
        this.toggleLoading(false);
        resolve()
      });
    })
  }

  toggleLoading(toggle) {
    if (this.processing === toggle) {
      return
    }

    this.processing = toggle;
    if (toggle) {
      this.icon = this.element.innerHTML;
      this.element.innerHTML = `<i class="fa fa-spinner fa-spin"></i>`;
      return;
    }

    this.element.innerHTML = this.icon;
  }

  confirmUndo(data){
    const sweetAlertOptions = {
      title: "",
      text: "",
      html: data,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Desfazer mesmo assim",
      cancelButtonText: "Cancelar"
    };

    swal(sweetAlertOptions).then((result) =>  {
      if (result.value) {
        this.handleUndo(true);
        return
      }

      this.toggleLoading(false);
    });
  }

  undoComplete(newLine){
    const containerElement = this.element.closest('tr')
    containerElement.insertAdjacentHTML('afterEnd', newLine);
    containerElement.remove()
    Swal.hideLoading()
    swal.close()
    toastr.success("Tratamento desfeito")
  }
}
